import { Link } from 'react-router-dom'
import logoColored from '../../assets/images/logo-colored.png'
import logoMark from '../../assets/images/logo-mark.png'
import { cn } from '../../lib/utils'

type LogoProps = {
  /** dark = wordmark on light backgrounds; light = icon + text on dark backgrounds */
  variant?: 'light' | 'dark'
  size?: 'sm' | 'md'
  /** When false, render a plain mark (no link). Default true. */
  linkToHome?: boolean
}

const WORDMARK_SIZE = {
  sm: 'h-8 w-auto',
  md: 'h-10 w-auto',
} as const

const MARK_SIZE = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
} as const

export function Logo({ variant = 'dark', size = 'md', linkToHome = true }: LogoProps) {
  const content =
    variant === 'light' ? (
      <span className="inline-flex items-center gap-2.5">
        <img
          src={logoMark}
          alt=""
          aria-hidden
          className={cn(MARK_SIZE[size], 'shrink-0 object-contain')}
        />
        <span className="font-display text-xl font-bold leading-none tracking-tight">
          <span className="text-white">Peer</span>
          <span className="text-gold">Med</span>
        </span>
      </span>
    ) : (
      <img
        src={logoColored}
        alt="PeerMed"
        className={cn(WORDMARK_SIZE[size], 'object-contain object-left')}
      />
    )

  if (!linkToHome) {
    return content
  }

  return (
    <Link to="/" className="inline-flex items-center" aria-label="PeerMed home">
      {content}
    </Link>
  )
}
